import moment from "moment";
import { clockFormat, locationDisplay } from "@1-now/booking-core";

export interface Stop {
  place: string;
  when: string;
}

/**
 * Where and when the trip starts and ends, worded as the bill's own "Booking
 * Details" does (CarListingDetailPage renderSidebarPrice), for the phone
 * booking's review step (1NOW-11155). startDate/endDate
 * already carry their time (utils/changeDate).
 */
export const tripStops = (t: {
  pickupLocation: any;
  dropOffLocation: any;
  /** false = the renter chose a different drop-off. */
  dropoffLocationType: boolean;
  startDate: Date | null;
  endDate: Date | null;
  ourCompany: any;
  tripDays?: number;
}): { pickup: Stop; dropoff: Stop; range: string } => {
  const name = t.ourCompany?.company_name;
  const when = (d: Date | null) =>
    d ? `${moment(d).format("ddd, D MMM YYYY")} · ${moment(d).format(clockFormat(t.ourCompany))}` : "";
  const days = Number(t.tripDays) || 0;
  return {
    pickup: { place: t.pickupLocation ? locationDisplay(t.pickupLocation, name) : "", when: when(t.startDate) },
    dropoff: {
      place:
        t.dropoffLocationType === false && t.dropOffLocation?.name
          ? locationDisplay(t.dropOffLocation, name)
          : t.pickupLocation
            ? locationDisplay(t.pickupLocation, name)
            : "",
      when: when(t.endDate),
    },
    range:
      t.startDate && t.endDate
        ? `${moment(t.startDate).format("MMM D")} – ${moment(t.endDate).format("MMM D")}${
            days ? ` · ${days} day${days === 1 ? "" : "s"}` : ""
          }`
        : "",
  };
};
